import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["nav", "scene", "desc", "dot"];
  static values = {
    interval: { type: Number, default: 6000 },
    index: { type: Number, default: 0 },
  };

  connect() {
    this._show(0);
    this._startTimer();
  }

  disconnect() {
    this._stopTimer();
  }

  goTo(event) {
    const index = parseInt(event.currentTarget.dataset.index, 10);
    this._show(index);
    this._restartTimer();
  }

  next() {
    const next = (this.indexValue + 1) % this.sceneTargets.length;
    this._show(next);
    this._restartTimer();
  }

  previous() {
    const count = this.sceneTargets.length;
    this._show((this.indexValue - 1 + count) % count);
    this._restartTimer();
  }

  // Private

  _show(index) {
    this.indexValue = index;

    this.navTargets.forEach((nav, i) => {
      if (i === index) {
        nav.classList.add("text-primary", "bg-primary/10", "font-semibold");
        nav.classList.remove("text-stone-400");
        nav.querySelector(
          ".material-symbols-outlined",
        ).style.fontVariationSettings = "'FILL' 1";
      } else {
        nav.classList.remove("text-primary", "bg-primary/10", "font-semibold");
        nav.classList.add("text-stone-400");
        nav.querySelector(
          ".material-symbols-outlined",
        ).style.fontVariationSettings = "";
      }
    });

    this.sceneTargets.forEach((scene, i) => {
      scene.classList.toggle("hidden", i !== index);
    });

    this.descTargets.forEach((desc, i) => {
      desc.classList.toggle("hidden", i !== index);
    });

    this.dotTargets.forEach((dot, i) => {
      dot.classList.toggle("bg-primary", i === index);
      dot.classList.toggle("bg-base-300", i !== index);
    });
  }

  _startTimer() {
    if (this._timerId) return;
    this._timerId = setInterval(() => {
      const next = (this.indexValue + 1) % this.sceneTargets.length;
      this._show(next);
    }, this.intervalValue);
  }

  _stopTimer() {
    clearInterval(this._timerId);
    this._timerId = null;
  }

  _restartTimer() {
    this._stopTimer();
    this._startTimer();
  }
}
